import ReactDOM from 'react-dom';
import { Line } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import './LinearChart.scss';
import ChartTooltip from './ChartTooltip';
import { useTranslation } from 'react-i18next';

const LinearChart = ({ labels, points, engines }) => {

    const { t, ready } = useTranslation();
    const data = {
        labels: labels,
        datasets: [
            {
                data: points,
                label: ' ',
                fill: false,
                lineTension: 0.1,
                backgroundColor: 'rgba(75,192,192,0.4)',
                borderColor: 'rgba(38, 114, 251, 1)',
                pointBorderColor: 'rgba(88, 102, 135, 1)',
                pointBackgroundColor: '#ffffff',
                pointBorderWidth: 7,
                pointHoverRadius: 10,
                pointHoverBackgroundColor: '#ffffff',
                pointHoverBorderColor: 'rgba(88, 102, 135, 1)',
                pointHoverBorderWidth: 7,
                pointRadius: 8,
                pointHitRadius: 8,

            }
        ]
    };

    const options = {
        scaleShowGridLines: false,
        legend: {
            display: false,
        },
        layout: {
            padding: {
                top: 30,
                right: 65,
                bottm: 30,
                left: 45
            }

        },
        labels: {
            display: false,
        },
        tooltips: {
            enabled: false,

            custom: function(tooltipModel) {
                let tooltipEl = document.getElementById('chartjs-tooltip');
                // Create element on first render
                if (!tooltipEl) {
                    tooltipEl = document.createElement('div');
                    tooltipEl.id = 'chartjs-tooltip';
                    document.body.appendChild(tooltipEl);
                }

                // Hide if no tooltip
                if (tooltipModel.opacity === 0) {
                    tooltipEl.style.opacity = 0;
                    return;
                }

                // Set caret Position
                tooltipEl.classList.remove('above', 'below', 'no-transform');
                if (tooltipModel.yAlign) {
                    tooltipEl.classList.add(tooltipModel.xAlign);
                } else {
                    tooltipEl.classList.add('above');
                }

                // Set Text
                if (tooltipModel.title) {
                    const titleLines = tooltipModel.title  || [];
                    let tooltipTitle = '';

                    titleLines.forEach((title) => {
                        if (title === 'MCL'){
                            tooltipTitle = t('Cloud');
                            return;
                        }
                        tooltipTitle += t(`${title.substr(1)} Engines`);
                    });

                    const enginesList = engines[tooltipModel.title[0]];
                    const tooltipBody = (<span> {enginesList} </span>);

                    ReactDOM.render(<ChartTooltip title={tooltipTitle} body={tooltipBody} />, tooltipEl);
                }

                // `this` will be the overall tooltip
                let position = this._chart.canvas.getBoundingClientRect();
                const leftPosition = position.left + window.pageXOffset + tooltipModel.caretX;

                // Display, position, and set styles for font
                tooltipEl.style.opacity = 1;
                tooltipEl.style.position = 'absolute';

                tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
                tooltipEl.style.pointerEvents = 'none';

                const positionLeft = document.getElementById('caret');
                if (window.innerWidth - leftPosition < 200) {
                    tooltipEl.style.left = leftPosition - 60 + 'px';
                    const positionLeft = document.getElementById('caret');
                    positionLeft.style.marginLeft = 55 + 'px';
                }
                else if (leftPosition < 150) {
                    tooltipEl.style.left = 150 + 'px';
                    const positionLeft = document.getElementById('caret');
                    positionLeft.style.marginLeft = -75 + 'px';
                }
                else {
                    positionLeft.style.marginLeft = 0 + 'px';
                }
            }
        },
        scales: {
            yAxes: [{
                ticks: {
                    stepSize: 10,
                    display: false,
                },
                gridLines: {
                    drawBorder: false,
                },
            }],
            xAxes: [{
                ticks: {
                    display: false,
                },
                gridLines: {
                    display: false,
                },
            }],

        }

    };

    if (!ready) {
        return null;
    }
    return (
        <div className="chart">
            <Line data={data} options={options}></Line>
        </div>
    );
};

LinearChart.propTypes = {
    labels: PropTypes.array,
    points: PropTypes.array,
    engines: PropTypes.array
};

export default LinearChart;

